import React, { Suspense, lazy, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom'
import { Toaster } from 'sonner'

const Landing = lazy(() => import('./app/page'))
const Admin = lazy(() => import('./app/admin/page'))
const AdminLogin = lazy(() => import('./app/admin/login/page'))
const Blog = lazy(() => import('./app/blog/page'))
const BlogPost = lazy(() => import('./app/blog/[slug]/page'))
const LegacyDashboard = lazy(() => import('./app/c/[token]/page'))
const Demo = lazy(() => import('./app/demo/[templateSlug]/page'))
const ClientForm = lazy(() => import('./app/form/[token]/page'))
const HubLogin = lazy(() => import('./app/hub/login/page'))
const HubManage = lazy(() => import('./app/hub/manage/[ownerToken]/page'))
const Onboard = lazy(() => import('./app/onboard/[token]/page'))
const Payment = lazy(() => import('./app/payment/[slug]/page'))
const Preview = lazy(() => import('./app/preview/[slug]/page'))
const Privacy = lazy(() => import('./app/privacy/page'))
const Publish = lazy(() => import('./app/publish/[slug]/page'))
const RefundPolicy = lazy(() => import('./app/refund-policy/page'))
const Status = lazy(() => import('./app/status/[token]/page'))
const Terms = lazy(() => import('./app/terms/page'))
const Wedding = lazy(() => import('./app/wedding/[slug]/page'))

function ShortLink() {
  const { id } = useParams()
  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL || ''}/api/s/${id}`)
  }, [id])
  return null
}

function ScrollTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-[#FDFBF7] text-[#3A3226] px-6" data-testid="not-found-page">
      <div className="text-center">
        <div className="text-[#8B7355] tracking-[0.3em] text-xs uppercase mb-4">404</div>
        <h1 className="font-serif text-4xl mb-4">Page not found</h1>
        <a href="/" className="underline text-[#8B7355]">Back to Vivoha</a>
      </div>
    </main>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Suspense fallback={<div className="min-h-screen bg-[#FDFBF7]" />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/c/:token" element={<LegacyDashboard />} />
          <Route path="/demo/:templateSlug" element={<Demo />} />
          <Route path="/form/:token" element={<ClientForm />} />
          <Route path="/hub/login" element={<HubLogin />} />
          <Route path="/hub/manage/:ownerToken" element={<HubManage />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/onboard/:token" element={<Onboard />} />
          <Route path="/payment/:slug" element={<Payment />} />
          <Route path="/preview/:slug" element={<Preview />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/publish/:slug" element={<Publish />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/status/:token" element={<Status />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/wedding/:slug" element={<Wedding />} />
          <Route path="/s/:id" element={<ShortLink />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  )
}
